import React from 'react';
import FormContainer from '../../forms/FormContainer/FormContainer';
import ButtonContainer from '../../forms/ButtonContainer/ButtonContainer';

export default function Success({ profileUrl }) {
    return (
        <FormContainer>
            <div>
                <h2>Product uploaded!</h2>
                <p>Thank you, your product has been submitted for review. We will let you know when it's active on your profile.</p>
                <ButtonContainer>
                    <a href="/marketplace/upload/" className="meatex-button">Upload another product</a>
                    {profileUrl && (<a href={profileUrl} className="meatex-button meatex-button--orange">View profile</a>)}
                </ButtonContainer>
            </div>
        </FormContainer>
    )
}
